import CustomComponent from "./CustomComponent";

export abstract class BaseContainer extends CustomComponent {
    createHeader(variant = 'vertical') {
        const element = this.createElementWithSlots('nxt-container-header', [
            'overline',
            'title',
            'subtitle',
            'header-body',
        ]);
        element.setAttribute('variant', variant);
        return element;
    }
}
